











import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ILabelValue } from '../../../../interfaces/generic'
import { timeout } from '../../../../helpers/generic'

@Component({})
export default class StatTracksImported extends Vue {
  @Prop()
  items: ILabelValue[]

  animatedItems: ILabelValue[] = []

  timeout: any = null

  @Watch('items', { immediate: true })
  animateItems() {
    this.animatedItems = []

    clearTimeout(this.timeout)

    this.timeout = setTimeout(async () => {
      if (this.animatedItems.length === 0) {
        for (const item of this.items) {
          this.animatedItems.push(item)

          await timeout(200)
        }
      }
    }, 200)
  }
}
